import React from 'react';
import DynamicForm, { withExtension } from 'components/Shared/DynamicForm';
import SampleDetailsSchema from 'schemas/sampleDetails.schema.json';
import { useAppContext } from 'hooks/useAppContext';
import SkeletonForm from 'components/Shared/SkeletonForm';


const SampleDetailsTab = ({ orientation, defaultValues, CRUDType, callback, disabledProperties, hiddenProperties }) => {
    const { selectedProjectData } = useAppContext();

    defaultValues["DateDeliveredProj"] = new Date(defaultValues.DateDeliveredProj).toLocaleDateString("en-US");


    return selectedProjectData ?
        withExtension(DynamicForm, { schema: SampleDetailsSchema, orientation, defaultValues, disabledProperties, hiddenProperties, readOnly: true, cardElevation: 0, inputVariant: "filled" }) :
        <SkeletonForm />
}

SampleDetailsTab.defaultProps = {
    orientation: "Horizontal",
    callback: () => { },
    defaultValues: {},
    disabledProperties: [],
    hiddenProperties: []
}

export default SampleDetailsTab
